import { Menu, MenuItem } from '@material-ui/core';
import cx from 'classnames';
import { camelCase } from 'lodash';

import PlusIcon from 'src/assets/icons/Plus';
import { CustomButton } from 'src/components/CustomButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { TruncatedTypography } from 'src/components/TruncatedTypography';
import { getProjectTypeLabel, getProjectTypeSubtitle, PROJECT_TYPE } from 'src/data/project';
import { usePopoverAnchor } from 'src/lib/hooks';
import { STONLY_ID } from 'src/lib/stonly';

import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';

const MENU_PROPS = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
  getContentAnchorEl: null,
};

const VISIBLE_PROJECT_TYPES = [PROJECT_TYPE.document, PROJECT_TYPE.longFormBuilder];

export const CreateContentItem = ({ className }) => {
  const styles = useStyles();

  const [anchorEl, openNewProjectMenu, closeNewProjectMenu] = usePopoverAnchor();

  const { handleNewProjectClick, handleCreateClick } = useHandlers({
    openNewProjectMenu,
    closeNewProjectMenu,
  });

  return (
    <>
      <CustomButton
        className={cx(styles.root, className)}
        onClick={handleNewProjectClick}
        startIcon={<PlusIcon />}
        data-stonly-id={STONLY_ID.createDocumentButton}
        data-testid="createContentButton"
      >
        Create content
      </CustomButton>
      <Menu
        classes={{
          paper: styles.menuPaper,
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeNewProjectMenu}
        variant="menu"
        keepMounted
        {...MENU_PROPS}
      >
        {VISIBLE_PROJECT_TYPES.map((projectType) => (
          <MenuItem
            key={projectType}
            className={styles.menuItem}
            onClick={() => handleCreateClick(projectType)}
            data-testid={`${camelCase(projectType)}Selector`}
          >
            <div className={styles.content}>
              <CustomTypography
                className={styles.label}
                variant={TYPOGRAPHY_VARIANT.medium14}
              >
                {getProjectTypeLabel(projectType)}
              </CustomTypography>
              <TruncatedTypography
                className={styles.subtitle}
                variant={TYPOGRAPHY_VARIANT.regular12}
              >
                {getProjectTypeSubtitle(projectType)}
              </TruncatedTypography>
            </div>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
